export default __webpack_public_path__ + "static/media/banner.1d5fc18d.jpg";